import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'reactstrap';
import { Filters, Utils } from '../../../services/';
import { Table, TableButtons } from '../../../components';

const TickettypesPricingsTable = ({ tickettypes }) => {
    const { t, i18n } = useTranslation();

    const pricings = useMemo(() => tickettypes?.reduce((all, tickettype) => {
        if (!tickettype.pricings)
            return all;

        Object.keys(tickettype.pricings).map(id => {
            const pricing = tickettype.pricings[id];
            all.push({
                ...pricing,
                id,
                _id: tickettype._id,
                tickettype_name: tickettype.name[i18n.language] ?? tickettype.name[Object.keys(tickettype.name)[0]],
                pricing_name: pricing.name[i18n.language] ?? pricing.name[Object.keys(pricing.name)[0]],
                sellers_names: pricing
                    .sellers?.map(r => t(`roles.${r}`) === `roles.${r}` ? r : t(`roles.${r}`))
                    .sort()
                    .join(', ')
            });
        });

        return all;
    }, []), [tickettypes]);

    const currency = Utils.currency();

    const columns = [{
        Header: t('common.tickettype', {count: 1}),
        accessor: 'tickettype_name',
        filterMethod: Filters.textFilterMethod('tickettype_name'),
        Filter: Filters.textFilter,
        filterAll: true,
        Cell: row => row.value ?? '-'
    }, {
        Header: t('tickettypes.pricing.name'),
        accessor: 'pricing_name',
        filterMethod: Filters.textFilterMethod('pricing_name'),
        Filter: Filters.textFilter,
        filterAll: true,
        maxWidth: 120,
    }, {
        Header: t('tickettypes.pricing.id'),
        accessor: 'id',
        filterable: false,
        maxWidth: 120,
    }, {
        Header: t('tickettypes.pricing.price'),
        accessor: `price.${currency}`,
        filterable: false,
        className: 'text-center',
        maxWidth: 80,
        Cell: row => (row.value || 0).toFixed(2)
    }, {
        Header: t('tickettypes.pricing.value'),
        accessor: `value.${currency}`,
        filterable: false,
        className: 'text-center',
        maxWidth: 80,
        Cell: row => (row.value || 0).toFixed(2)
    }, {
        Header: t('tickettypes.pricing.vat'),
        accessor: 'vat',
        filterable: false,
        className: 'text-center',
        maxWidth: 50,
        Cell: row => row.value ? row.value.toFixed(2) : ''
    }, {
        Header: t('tickettypes.pricing.sellers'),
        accessor: 'sellers_names',
        filterMethod: Filters.textFilterMethod('sellers_names'),
        Filter: Filters.textFilter,
        filterAll: true,
    }, {
        Header: t('tickettypes.pricing.category'),
        accessor: 'category',
        maxWidth: 80,
        className: 'text-center',
        filterable: false
    }, {
        Header: t("common.actions"),
        accessor: "_id",
        maxWidth: 80,
        filterable: false,
        Cell: row => (
            <TableButtons
                id={row.value}
                actions={["edit"]}
                module="tickettypes"
            />
        )
    }]
    if (!tickettypes?.length || !pricings?.length)
        return null;

    return (
        <div className="TickettypesPricingsTable">
            <Table id="tickettypesPricingsTable" data={pricings} columns={columns} />
        </div>
    );
}

export default TickettypesPricingsTable;
